import { render, staticRenderFns } from "./bandeiras.vue?vue&type=template&id=a14f154c"
import script from "./bandeiras.vue?vue&type=script&lang=js"
export * from "./bandeiras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports